import React from 'react'
import InputField from 'components/molecules/input-field'
import CardTextData from 'components/molecules/card-text-data'
import PropTypes from 'prop-types'
import { FormGroup } from 'reactstrap'

const propTypes = {
  id              : PropTypes.string,
  label           : PropTypes.string,
  initialImageSrc : PropTypes.string,
  required        : PropTypes.bool,
  setValue        : PropTypes.func
}

const defaultProps = {
  id              : '',
  label           : '',
  initialImageSrc : '',
  required        : false,
  setValue        : () => {}
}

const VoucherImageField = ({
  id,
  label,
  initialImageSrc,
  required,
  setValue
}) => {

  const onChange = (event, setValue, id) => {
    const input  = event.target.files[0]
    const reader = new FileReader()

    reader.readAsDataURL(input)
    reader.onload = () => {
      var dataURL = reader.result
      var output  = document.getElementById(id)
      output.src  = dataURL
      setValue(input)
    }
  }

  const InitialImage = ({ initialImageSrc }) => {

    if (!initialImageSrc) return null

    return (
      <CardTextData
        label='Current Image'
        value={
          <img
            src={ initialImageSrc }
            className='mb-4'
            width='200'
            alt='initial'
          />
        }
      />
    )

  }

  return (
    <FormGroup>
      <InputField
        name={ id }
        label={ label }
        required={ required }
        type='file'
        accept='image/*'
        onChange={ (event) => {
          onChange(event, setValue, id )
        } }
      />

      { /*initial image (example case: update image)*/ }
      <InitialImage initialImageSrc={ initialImageSrc } />

      <div>
        <img
          id={ id }
          className='w-100'
        />
      </div>
    </FormGroup>
  )
}

VoucherImageField.propTypes    = propTypes
VoucherImageField.defaultProps = defaultProps

export default VoucherImageField
